import React, { useContext, useState } from "react";
import { HStack } from "@design-system/HStack/HStack";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import classNames from "classnames";
import { useMobileView } from "@hooks/useMobileView";
import { Loader } from "@design-system/Loader/Loader";
import { StandardModal } from "@design-system/Modal/Modal";
import { DocumentIcon } from "@icons";
import { Button } from "@design-system/Button/Button";
import { Menu } from "@design-system/Menu/Menu.lib";
import { useReceiptUpload } from "../../ReceiptUpload/useReceiptUpload";
import { RECEIPT_UPLOAD_HIGHLIGHTED_ELEMENT } from "../../ReceiptUpload/lib";
import { TransactionMatchingContainer } from "../TransactionMatching/TransactionMatchingContainer";
import { TransactionDetailsContext } from "../transactionDetails.context";
import styles from "./TransactionMatches.module.scss";

export const TransactionMatchesAddReceipt: React.FC = () => {
    const mobile = useMobileView();
    const { transaction } = useContext(TransactionDetailsContext);
    const { inputProps, isDragActive, isUploading, open } = useReceiptUpload();
    const [showMatchingModal, setShowMatchingModal] = useState(false);

    let label: React.ReactNode;
    if (mobile) {
        label = <>Tap to add receipt</>;
    } else if (isDragActive) {
        label = <>Drop your file to upload</>;
    } else {
        label = <>Upload receipt</>;
    }

    return (
        <>
            <Tooltip content="Drop any files here or click to upload">
                <div
                    className={classNames(
                        RECEIPT_UPLOAD_HIGHLIGHTED_ELEMENT,
                        styles.addReceipt,
                    )}
                    data-testid="transaction-matches-add-receipt"
                >
                    <input
                        data-testid="transaction-matches-add-receipt-input d-none"
                        {...inputProps}
                    />

                    {isUploading ? (
                        <div className={styles.uploading}>
                            <Loader inline />
                        </div>
                    ) : (
                        <Menu.Root
                            trigger={
                                <Button
                                    className={styles.uploadTriggerButton}
                                    variant="primary"
                                    block
                                    size="xl"
                                >
                                    <HStack
                                        justify="between"
                                        align="center"
                                        className="w-100"
                                    >
                                        <span>{label}</span>
                                        <DocumentIcon />
                                    </HStack>
                                </Button>
                            }
                        >
                            <Menu.Item onClick={open}>Upload Receipt</Menu.Item>
                            <Menu.Item
                                onClick={() => setShowMatchingModal(true)}
                            >
                                Browse from documents
                            </Menu.Item>
                        </Menu.Root>
                    )}
                </div>
            </Tooltip>
            <StandardModal
                className="fullscreen-modal"
                show={showMatchingModal}
                onHide={() => setShowMatchingModal(false)}
            >
                {transaction && showMatchingModal && (
                    <TransactionMatchingContainer transaction={transaction} />
                )}
            </StandardModal>
        </>
    );
};
